<template>
  <div class="filter-broker-pre-register mb-4">
    <ValidationObserver
      ref="formFilter"
      class="flex flex-col"
      v-slot="{ invalid }"
    >
      <vs-card>
        <div class="grid-container mb-4">
          <div class="w-full">
            <span>Corretora</span>
            <vs-input
              data-testid="broker-input"
              id="broker-input"
              icon="search"
              placeholder="Razão Social"
              class="w-full"
              v-model="formFilters.broker"
            />
          </div>

          <ValidationProvider
            name="CPF/CNPJ"
            rules="cpf_cnpj_min"
            v-slot="{ errors }"
            class="w-full"
          >
            <span>CPF/CNPJ</span>
            <vs-input
              data-testid="cpf-cnpj-input"
              id="cpf-cnpj-input"
              icon="search"
              placeholder="CPF/CNPJ"
              class="w-full"
              v-mask="[DOCUMENT_MASK.CPF_WITH_CNPJ, DOCUMENT_MASK.CNPJ]"
              @input="formFilters.cnpj = $event.toUpperCase()"
              v-model="formFilters.cnpj"
              :danger="!!errors.length"
            />
            <span
              v-show="!!errors.length"
              class="text-danger"
              data-testId="cpf-cnpj-error"
              >{{ errors[0] }}</span
            >
          </ValidationProvider>

          <div class="w-full">
            <span>Status</span>
            <v-select
              data-testid="status-select"
              id="status-select"
              multiple
              name="Status"
              class="input-select"
              :options="statusOptions"
              label="label"
              :reduce="(o) => o.value"
              v-model="formFilters.statuses"
            />
          </div>

          <div class="w-full">
            <span>Assessoria</span>
            <AutoComplete
              id="consultancies-select"
              class="w-full"
              data-testid="consultancies-select"
              name="Assessoria"
              :configAutoComplete="{
                model: 'Broker_Pre_Register',
                field: 'consultancy_name',
              }"
              v-model="formFilters.consultancy"
              :minimumCharacters="3"
            />
          </div>

          <div class="w-full">
            <span>Portal</span>
            <v-select
              class="w-full"
              name="Portal"
              id="portal-select"
              data-testid="portal-select"
              multiple
              :closeOnSelect="false"
              :options="portalOptions"
              label="label"
              :reduce="(o) => o.value"
              v-model="formFilters.portals"
            />
          </div>

          <ValidationProvider
            name="Tipo de Data"
            :rules="{
              required:
                formFilters.dateRange.initialDate != null ||
                formFilters.dateRange.endDate != null,
            }"
            v-slot="{ errors }"
            class="w-full"
          >
            <span>Tipo de Data</span>
            <v-select
              data-testid="initial-date-type-select"
              class="w-full"
              :options="filtersOptions.dateTypes"
              :reduce="(option) => option.id"
              label="label"
              id="date-type-select"
              v-model="formFilters.dateRange.dateType"
              @input="handleDateTypeChange"
              :danger="!!errors.length"
            />
            <span
              v-show="!!errors.length"
              class="text-danger"
              data-testId="end-date-error"
              >{{ errors[0] }}</span
            >
          </ValidationProvider>

          <ValidationProvider
            name="Data Inicial"
            :rules="{
              required:
                formFilters.dateRange.dateType != null ||
                formFilters.dateRange.endDate != null,
            }"
            v-slot="{ errors }"
            class="w-full"
          >
            <span>Data Inicial</span>
            <datepicker
              data-testid="initial-date-datepicker"
              id="initial-date-datepicker"
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              class="w-full"
              :disabled-dates="getConfigStartDatePicker()"
              v-model="formFilters.dateRange.initialDate"
              @input="checkEndDateIsValid"
              :danger="!!errors.length"
            />
            <span
              v-show="!!errors.length"
              class="text-danger"
              data-testId="end-date-error"
              >{{ errors[0] }}</span
            >
          </ValidationProvider>

          <ValidationProvider
            name="Data Final"
            :rules="{
              required:
                formFilters.dateRange.dateType != null ||
                formFilters.dateRange.initialDate != null,
            }"
            v-slot="{ errors }"
            class="w-full"
          >
            <span>Data Final</span>
            <datepicker
              data-testid="final-date-datepicker"
              id="final-date-datepicker"
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              class="w-full"
              v-model="formFilters.dateRange.endDate"
              :danger="!!errors.length"
              :disabled-dates="getConfigEndDatePicker()"
            />
            <span
              v-show="!!errors.length"
              class="text-danger"
              data-testId="end-date-error"
              >{{ errors[0] }}</span
            >
          </ValidationProvider>
        </div>
      </vs-card>

      <div class="buttons-container">
        <div class="bg-white mr-3">
          <vs-button
            color="success"
            type="border"
            icon-pack="feather"
            icon="icon-download"
            icon-after
            @click="exportFile"
          >
            Exportar
          </vs-button>
        </div>
        <div class="bg-white">
          <vs-button
            data-testid="search-button"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="mr-3"
            @click="searchFilters"
            :disabled="invalid"
          >
            Buscar
          </vs-button>
        </div>
        <vs-button
          data-testid="clear-button"
          @click="resetFilters"
          color="danger"
          type="gradient"
          icon-pack="feather"
          icon="icon-trash-2"
        />
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import AutoComplete from '../../components/autocomplete/AutoComplete.vue';
import { DOCUMENT_MASK } from '../../constants/cpfCnpj.js';
import brokersPreRegister from '../../services/brokers-pre-register.js';
import { capitalizeFirstLetter } from '../../utils/capitalizeFirstLetter.js';
import notify from '../../utils/notify';
import { BROKER_PRE_REGISTER_STATUS } from '../menu/cadastros/broker-pre-register/constants/broker.pre.register';

export default {
  name: 'FilterBrokerPreRegister',
  components: {
    AutoComplete,
    Datepicker,
    'v-select': vSelect,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    initialFilters: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      DOCUMENT_MASK,
      capitalizeFirstLetter,
      filtersOptions: {
        portals: [],
        statuses: [],
        dateTypes: [],
      },
      formFilters: this.buildInitialFormFilters(),
    };
  },
  computed: {
    statusOptions() {
      return (this.filtersOptions.statuses || []).map(function (s) {
        return { label: capitalizeFirstLetter(s), value: s };
      });
    },
    portalOptions() {
      return (this.filtersOptions.portals || []).map(function (p) {
        return { label: p, value: p };
      });
    },
  },
  watch: {
    formFilters: {
      handler: function () {
        var self = this;
        this.$nextTick(function () {
          if (self.$refs.formFilter && self.$refs.formFilter.validate) {
            self.$refs.formFilter.validate();
          }
        });
      },
      deep: true,
    },
    initialFilters: {
      handler: function (newVal, oldVal) {
        if (!newVal || JSON.stringify(newVal) === JSON.stringify(oldVal))
          return;

        this.formFilters = this.buildInitialFormFilters();
      },
      deep: true,
    },
  },
  async created() {
    await this.getFiltersData();
    if (this.initialFilters) {
      this.formFilters = this.buildInitialFormFilters();
    }
  },
  mounted() {
    if (!this.initialFilters || Object.keys(this.initialFilters).length === 0) {
      this.$emit('search');
    }
  },
  methods: {
    getConfigEndDatePicker() {
      var initialDate = this.formFilters.dateRange.initialDate;
      return {
        to: initialDate ? new Date(initialDate) : null,
        from: new Date(),
      };
    },
    getConfigStartDatePicker() {
      return { from: new Date() };
    },
    handleDateTypeChange(value) {
      if (value) return;
      this.formFilters.dateRange.initialDate = null;
      this.formFilters.dateRange.endDate = null;
    },
    checkEndDateIsValid(value) {
      var initialDate = new Date(value);
      var endDate = new Date(this.formFilters.dateRange.endDate);
      if (initialDate > endDate) {
        this.formFilters.dateRange.endDate = null;
      }
    },

    getDefaultFormFilters() {
      return {
        broker: null,
        cnpj: null,
        consultancy: null,
        portals: [],
        statuses: [
          BROKER_PRE_REGISTER_STATUS.PENDING,
          BROKER_PRE_REGISTER_STATUS.PENDING_DOCUMENTATION,
          BROKER_PRE_REGISTER_STATUS.MANUAL_REGISTRATION,
          BROKER_PRE_REGISTER_STATUS.EXTERNAL_REGISTRATION,
        ],
        dateRange: {
          dateType: null,
          initialDate: null,
          endDate: null,
        },
      };
    },
    buildInitialFormFilters() {
      if (this.initialFilters) {
        return Object.assign(
          {},
          this.getDefaultFormFilters(),
          this.initialFilters,
        );
      }
      return this.getDefaultFormFilters();
    },

    clone(v) {
      if (Array.isArray(v)) return v.slice();
      if (typeof v === 'object' && v !== null)
        return JSON.parse(JSON.stringify(v));
      return v;
    },

    exportFile() {
      this.$emit('exportFile');
    },
    resetFilters() {
      this.formFilters = this.getDefaultFormFilters();
      this.searchFilters();
    },
    searchFilters() {
      if (!Array.isArray(this.formFilters.statuses)) {
        this.formFilters.statuses = [];
      }
      var payload = this.clone(this.formFilters);
      if (!payload.dateRange) payload.dateRange = {};
      if (payload.dateRange.initialDate)
        payload.dateRange.startDate = payload.dateRange.initialDate;
      if (payload.dateRange.endDate)
        payload.dateRange.endDate = payload.dateRange.endDate;

      this.$emit('search', payload);
    },

    async getFiltersData() {
      this.$vs.loading();
      try {
        const filters = await brokersPreRegister.getBrokersPreRegisterFilters();
        this.filtersOptions.portals = filters.portals || [];
        this.filtersOptions.statuses = filters.statuses || [];
        this.filtersOptions.dateTypes = filters.dateTypes || [];
      } catch (error) {
        notify.notifyFail(this.$vs, 'Falha ao buscar filtros');
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>

<style>
.filter-broker-pre-register {
  .vdp-datepicker__calendar {
    z-index: 900 !important;
  }
  .vdp-datepicker input {
    width: 100%;
  }
  .vs__dropdown-toggle {
    min-height: 2.6rem !important;
    flex: 1;
  }

  .buttons-container {
    display: flex;
    justify-content: flex-end;
    margin-top: -4rem;
    padding: 1rem;
  }

  .grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(calc(25% - 1rem), 1fr));
    gap: 1rem;
  }

  @media screen and (max-width: 768px) {
    .grid-container {
      grid-template-columns: repeat(auto-fill, minmax(calc(50% - 1rem), 1fr));
    }
  }
  @media screen and (max-width: 480px) {
    .grid-container {
      grid-template-columns: repeat(auto-fill, minmax(calc(100% - 1rem), 1fr));
    }
  }
}
</style>
